<template>
    <form class="form-horizontal callout" v-if="$auth.isPartner" @submit.prevent="validate">
        <div class="form-group row">
            <label class="col-md-2 col-form-label"><strong>Deseja uma nova entrada para:</strong></label>
            <div class="col-md-10 col-form-label">
                <div class="form-check form-check-inline mr-5">
                    <input v-model="partnerRequest.type" class="form-check-input" id="inline-radio1" type="radio" :value="'Seller'" name="inline-radios">
                    <label class="form-check-label" for="inline-radio1">Empresa</label>
                </div>
                <div class="form-check form-check-inline mr-1">
                    <input v-model="partnerRequest.type" class="form-check-input" id="inline-radio2" type="radio" :value="'Salesperson'" name="inline-radios">
                    <label class="form-check-label" for="inline-radio2">Representante</label>
                </div>                            
            </div>
        </div>
        <div class="form-row justify-content-start">
            <div class="col-md-3">
                <label>Selecione {{partnerRequest.label}}:</label>
                <model-list-select :list="partnerRequest.data"
                    option-value="id"
                    option-text="name"
                    v-model="partnerRequest.selected"
                    :placeholder="`Digite o nome d${partnerRequest.label}`"
                    @searchchange="searchData">
                </model-list-select>
            </div>
        </div>
        <div class="form-row mt-4 justify-content-start">
            <div class="col">
                <input type="submit" class="btn btn-primary" value="Selecionar">
                <label class="ml-4 text-danger" v-show="partnerRequest.selected == 0">Selecione {{partnerRequest.label}}!</label>
            </div>            
        </div>
    </form>
</template>
<script>
import { ModelListSelect } from 'vue-search-select'
import sellerService from '../services/Customer/sellerService'
import salesPersonService from '../services/Customer/salesPersonService'

export default {
    components: {
        ModelListSelect
    },
    data() {
        return {
            partnerRequest: {
                type: 'Seller',
                label: 'a Empresa',
                selected: 0,
                data: []
            }
        }
    },
    watch: {
        'partnerRequest.type' : function (n) {
            this.partnerRequest.label = n == 'Seller' ? 'a Empresa' : 'o Representante'
            this.partnerRequest.selected = ''
            this.partnerRequest.data = []
        }
    },
    filters: {
        stringify(value) {
            return JSON.stringify(value, null, 2)
        }
    },
    methods: {
        searchData(query) {
            if(query == null) {
                return
            }
            if(this.partnerRequest.type == 'Seller')
            {
                this.searchSellers(query)
            }
            else
            {
                this.searchSalesPeople(query)
            }
        },
        searchSellers(newQuery) {
            if(newQuery.length < 2)
                return
            const self = this
            //this.showLoading()
            sellerService.all(newQuery).then((response) =>{
                self.partnerRequest.data = response.status == 204 ? [] : response.data
                //self.hideLoading()
            }, () =>{
                //self.hideLoading()
            })
        },
        searchSalesPeople(q) {
            if(q.length < 2)
                return
            const self = this
            //this.showLoading()
            salesPersonService.all(q, '').then((response) =>{
                self.partnerRequest.data = response.status == 204 ? [] : response.data
                //self.hideLoading()
            }, () =>{
                //self.hideLoading()
            })
        },
        validate() {
            if(this.partnerRequest.selected != 0) {
                const self = this
                let customer = self.partnerRequest.data.find(function(item) { return item.id == self.partnerRequest.selected })
                this.$emit('onPartnerFilterSelected', {
                    role: this.partnerRequest.type,
                    id: this.partnerRequest.selected,
                    name: customer.name,
                    documentNumber: customer.documentNumber
                })
            }
        }
    }
}
</script>